"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorNotification = exports.ErrorNotification = void 0;
var tslib_1 = require("tslib");
var ErrorNotification_1 = require("@reactionable/core/lib/ui/notification/ErrorNotification");
var react_1 = tslib_1.__importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var ErrorAlert_1 = require("../alert/ErrorAlert");
var Notification_1 = require("./Notification");
exports.ErrorNotification = function (props) {
    if (!props.title) {
        var t = react_i18next_1.useTranslation().t;
        props.title = t('An error has occured');
    }
    return (react_1.default.createElement(Notification_1.Notification, tslib_1.__assign({ variant: "danger" }, props),
        react_1.default.createElement(ErrorAlert_1.ErrorAlert, { className: "mb-0" }, props.children)));
};
exports.useErrorNotification = function (props) {
    var notificationTitle;
    if (props.title === undefined) {
        var t = react_i18next_1.useTranslation().t;
        notificationTitle = t('An error has occured');
    }
    else {
        notificationTitle = props.title;
    }
    return ErrorNotification_1.useErrorNotification({
        title: notificationTitle,
        Component: exports.ErrorNotification,
    });
};
//# sourceMappingURL=ErrorNotification.js.map